import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=43f80f30&scoped=true&lang=pug&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"
import style0 from "./icon.vue?vue&type=style&index=0&id=43f80f30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f80f30",
  null
  
)

export default component.exports